const ChartColors = () => {
  const colors = [
    "#2662d9",
    "#8BC1F7",
    "#BDE2B9",
    "#73C5C5",
    "#B2B0EA",
    "#519DE9",
    "#7CC674",
    "#005F60",
    "#b3d4ff",
    "#00bfa0",
    "#b30000",
    "#5752D1",
    "#004B95",
    "#38812F",
    "#003737",
    "#0d88e6",
    "#2A265F",
    "#5ad45a",
    "#8be04e",
    "#ebdc78",
    "#fd7f6f",
    "#7eb0d5",
    "#b2e061",
    "#bd7ebe",
    "#ffb55a",
    "#ffee65",
    "#beb9db",
    "#fdcce5",
    "#8bd3c7",
    "#1984c5",
    "#22a7f0",
    "#63bff0",
    "#a7d5ed",
    "#e2e2e2",
    "#e1a692",
    "#de6e56",
    "#e14b31",
    "#c23728",
    "#e27c7c",
    "#a86464",
    "#6d4b4b",
    "#503f3f",
    "#333333",
    "#3c4e4b",
    "#466964",
    "#599e94",
    "#6cd4c5",
  ];

  return colors;
};

export default ChartColors;
export const pieColors = [
  "#27AE60",
  "#3498DB",
  "#E67E22",
  "#E74C3C",
  "#1ABC9C",
  "#9B59B6",
  "#95A5A6",
  "#F1C40F",
  "#34495E",
  "#D35400",
  "#C0392B",
  "#16A085",
  "#2980B9",
  "#F39C12",
  "#7F8C8D",
  "#2C3E50",
  "#AF7AC5",
  "#48C9B0",
  "#5DADE2",
  "#52BE80",
  "#F4D03F",
  "#DC7633",
  "#EC7063",
  "#AAB7B8",
  "#566573",
  "#7D3C98",
  "#1F618D",
  "#239B56",
];
